import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ModalState {
  modalType: string;
  isOpen: boolean;
  currentFilters: Record<string, string[]>;
}

const initialState: ModalState = {
  modalType: '',
  isOpen: false,
  currentFilters: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModalType: (state, action: PayloadAction<string>) => {
      state.modalType = action.payload;
    },
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setCurrentFilters: (state, action: PayloadAction<Record<string, string[]>>) => {
      state.currentFilters = action.payload;
    },
    clearFilters: (state) => {
      state.currentFilters = {};
    },
  },
});

export const { setModalType, setIsOpen, setCurrentFilters, clearFilters } = modalSlice.actions;
export default modalSlice.reducer;
